<script>
import {
  Button, Input, Modal, Icon,
} from '@/packages/ui/components';

export default {
  name: 'Popup',
  components: {
    Button, Input, Modal, Icon,
  },
  model: {
    prop: 'show',
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    confirmClose: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    cancelFunction: {
      type: Function,
      default: () => {},
    },
    submitFunction: {
      type: Function,
      default: () => {},
    },
    singleButton: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Boolean,
      default: false,
    },
    spacing: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    titleLeft: {
      type: Boolean,
      default: false,
    },
    buttonCancelLabel: {
      type: String,
      default: '',
    },
    buttonConfirmLabel: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'alert',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    insertText: {
      type: Boolean,
      default: false,
    },
    textFieldLabel: {
      type: String,
      default: '',
    },
    closeIcon: {
      type: Boolean,
      default: false,
    },
    btnRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      userText: '',
    };
  },
  computed: {
    showInternalDialog: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    styleComputed() {
      return {
        '-titleLeft': this.titleLeft,
        '-spacing': this.spacing,
        '-flex': this.flex,
        '-btnRight': this.btnRight,
      };
    },
    innerCancelLabel() {
      if (!this.buttonCancelLabel) {
        return this.$t('general.popup.cancel_button_label');
      }
      return this.buttonCancelLabel;
    },
    innerConfirmLabel() {
      if (!this.buttonConfirmLabel) {
        return this.$t('general.popup.confirm_button_label');
      }
      return this.buttonConfirmLabel;
    },
  },
  methods: {
    hideShowDialog() {
      this.$emit('cancel');
      this.userText = '';
      this.showInternalDialog = false;
    },
    chooseImage() {
      switch (this.type) {
        case 'alert':
          return 'popup/alert.svg';
        case 'error':
          return 'popup/error.svg';
        case 'success':
          return 'popup/success.svg';
        default:
          return 'popup/alert.svg';
      }
    },
    async internalSubmit() {
      this.loading = true;
      this.$emit('onClick');
      await this.submitFunction({ userText: this.userText });
      if (this.singleButton) {
        this.hideShowDialog();
      }
      this.userText = '';
      if (this.confirmClose) {
        this.showInternalDialog = false;
      }
      this.loading = false;
    },
    updateShow(v) {
      this.$emit('input', v);
    },
  },
};
</script>

<template>
  <div>
    <Modal
      :show="show"
      :persistent="persistent"
      @input="updateShow"
    >
      <Icon
        v-if="closeIcon"
        name="remove"
        class="cxm-Popup"
        color="var(--track-color-bluegray-70)"
        :handle-click="hideShowDialog"
      />
      <div
        class="cxm-Popup-AlignCenter"
        :class="[styleComputed,type]"
      >
        <center
          class="cxm-Popup-CenterImage"
          :class="[styleComputed]"
        >
          <div :class="[icon ? 'cxm-Popup-IconInner' : '']">
            <Icon
              v-if="icon"
              color="var(--track-color-white)"
              name="warning"
            />
            <img
              v-else
              :src="chooseImage()"
              style="width: 100px"
            >
          </div>
        </center>
        <div
          class="cxm-Popup-Title"
          :class="[styleComputed]"
        >
          {{ title }}
        </div>
        <div
          v-if="content"
          class="cxm-Popup-Content"
          :class="[styleComputed]"
        >
          {{ content }}
        </div>
        <slot />
        <div
          v-if="insertText"
          class="cxm-Popup-TextField"
        >
          <Input
            v-model="userText"
            autogrow
            :placeholder="textFieldLabel || $t('general.type_here')"
          />
        </div>

        <center
          class="cxm-Popup-Center"
          :class="[styleComputed]"
        >
          <Button
            v-show="!singleButton"
            :label="innerCancelLabel"
            :handle-click="
              () => {
                hideShowDialog();
                cancelFunction();
              }
            "
            type="tertiary"
          />
          <Button
            class="cxm-Popup-ConfirmBtn"
            :label="innerConfirmLabel"
            :handle-click="internalSubmit"
            :disabled="loading"
          />
        </center>
      </div>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.cxm-Popup-Title {
  font-weight: var(--track-font-weight-semibold);
  font-size: 21px;
  text-align: center;
  margin-bottom: var(--track-spacing-md);
  &.-titleLeft {
    text-align: left;
    color: var(--track-color-bluegray-80) !important;
    margin-top: var(--track-spacing-md);
    margin-bottom: 0px;

  }
}

.cxm-Popup-IconInner {
  border-radius: var(--track-border-radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: var(--track-color-neutral-darkest);
}
.cxm-Popup-Center {
  margin-top: var(--track-spacing-lg);
  &.-btnRight{
    display: flex;
    justify-content: end;
  }
}

.cxm-Popup-CenterImage {
  margin-bottom: var(--track-spacing-sm);
  &.-flex{
    display: flex;
    border-radius: var(--track-border-radius-full);
    padding: 12px;
    background-color: var(--track-color-neutral-lightest);
    width: 55px;
  }
}

.alert .cxm-Popup-Title {
  color: #f5a623;
}
.success .cxm-Popup-Title {
  color: #54ca7e;
}
.error .cxm-Popup-Title {
  color: #ea575f;
}
.cxm-Popup-Content {
  font-size: var(--track-font-size-xs);
  color: #a8aab7;
  text-align: center;
  white-space: pre-line;
  margin-bottom: 5px;
  &.-titleLeft {
    text-align: left;
    color: var(--track-color-bluegray-80);
    width: 78%;
    line-height: 140%;
    height: 40px;
  }
}
.cxm-Popup-ConfirmBtn {
  margin-left: 12px;
}
.cxm-Popup-TextField {
  margin-bottom: 21px;
}
.cxm-Popup-AlignCenter {
  max-width: 600px;
  padding: var(--track-spacing-lg);
  &.-spacing {
    width: 600px;
    padding: var(--track-spacing-bg);
  }
}
.cxm-Popup {
  margin: 22px 22px 0 0;
  float: right;
}
</style>
